import * as crypto from 'crypto-browserify';

const ALGORITHM = 'aes-256-cbc';
const IV_LENGTH = 16;

/**
 * Encrypt data using AES-256-CBC
 */
export function encrypt(data: string, keyString: string): string {
  try {
    const iv = crypto.randomBytes(IV_LENGTH);
    const key = Buffer.from(keyString, 'hex');

    const cipher = crypto.createCipheriv(ALGORITHM, key, iv);
    let encrypted = cipher.update(data, 'utf8', 'base64');
    encrypted += cipher.final('base64');

    return `ENC:${iv.toString('base64')}:${encrypted}`;
  } catch (error) {
    console.error('Encryption failed:', error);
    throw new Error('Failed to encrypt data');
  }
}

/**
 * Decrypt data using AES-256-CBC
 */
export function decrypt(encryptedData: string, keyString: string): string {
  try {
    if (!encryptedData.startsWith('ENC:')) {
      return encryptedData; // plain text
    }

    const [, ivBase64, encryptedText] = encryptedData.split(':');
    const iv = Buffer.from(ivBase64, 'base64');
    const key = Buffer.from(keyString, 'hex');

    const decipher = crypto.createDecipheriv(ALGORITHM, key, iv);
    let decrypted = decipher.update(encryptedText, 'base64', 'utf8');
    decrypted += decipher.final('utf8');

    return decrypted;
  } catch (error) {
    console.error('Decryption failed:', error);
    throw new Error('Failed to decrypt data');
  }
}

export function isEncrypted(str: string): boolean {
  if (!str || typeof str !== 'string') return false;
  if (!str.startsWith('ENC:')) return false;
  const parts = str.split(':');
  // Expected format: ENC:<ivBase64>:<ciphertextBase64>
  return parts.length === 3 && parts[1].length > 0 && parts[2].length > 0;
}

export function maskPassword(password: string): string {
  if (!password) return '';
  // Do not leak real length for encrypted values
  if (isEncrypted(password)) return '********';
  return '*'.repeat(Math.min(password.length, 8));
}
